/* src/app/layout/mobile-menu/mobile-menu.component.scss */
.di-mobile-menu-wrapper {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  z-index: 99;
  left: -100%;
  transition: all 0.05s;
}
.di-mobile-menu-wrapper .mobile-menu-bg {
  background: rgba(0, 0, 0, 0.5);
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  opacity: 0;
  transition: fadeIn 0.2s;
}
.di-mobile-menu-wrapper .mobile-menu-data {
  max-width: 300px;
  background: #fff;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
  height: 100vh;
  overflow: auto;
  position: relative;
  z-index: 10;
  left: -300px;
  transition: all 0.5s;
}
.di-mobile-menu-wrapper .mobile-menu-data .profile-header-wrapper {
  padding: 20px;
  background-color: #004c93;
  position: relative;
}
.di-mobile-menu-wrapper .mobile-menu-data .profile-header-wrapper .closeMenu {
  position: absolute;
  top: 15px;
  right: 15px;
  background-color: transparent;
  border: 0;
  height: 24px;
  width: 24px;
  font-size: 24px;
  padding: 0;
}
.di-mobile-menu-wrapper .mobile-menu-data .profile-header-wrapper .closeMenu .material-symbols-outlined {
  font-size: 24px;
  color: #fff;
}
.di-mobile-menu-wrapper .mobile-menu-data .profile-header-wrapper .user-profile {
  display: flex;
  align-items: center;
  margin: 0 0 20px 0;
}
.di-mobile-menu-wrapper .mobile-menu-data .profile-header-wrapper .user-profile .profile-image {
  min-width: 64px;
  width: 64px;
  height: 64px;
  margin: 0 15px 0 0;
}
.di-mobile-menu-wrapper .mobile-menu-data .profile-header-wrapper .user-profile .profile-image .name-tag {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 1.286rem;
  color: #004c93;
}
.di-mobile-menu-wrapper .mobile-menu-data .profile-header-wrapper .user-profile .user-details {
  color: #fff;
}
.di-mobile-menu-wrapper .mobile-menu-data .profile-header-wrapper .user-profile .user-details h4 {
  font-size: 1.1rem;
  font-weight: 600;
  margin: 0;
  line-height: 1;
}
.di-mobile-menu-wrapper .mobile-menu-data .profile-header-wrapper .user-profile .user-details p {
  font-size: 0.857rem;
  margin: 0;
  font-weight: 300;
}
.di-mobile-menu-wrapper .mobile-menu-data .profile-header-wrapper .user-profile .user-details .edit-logout-links a {
  font-size: 0.857rem;
}
.di-mobile-menu-wrapper .mobile-menu-data .profile-header-wrapper .user-profile .user-details .edit-logout-links a:first-child {
  margin-right: 10px;
}
.di-mobile-menu-wrapper .mobile-menu-data .profile-header-wrapper .di-product-dropdown {
  width: 100%;
}
.di-mobile-menu-wrapper .mobile-menu-data nav.di-nav {
  margin-top: 0 !important;
}
.di-mobile-menu-wrapper .mobile-menu-data nav.di-nav ul {
  margin: 0;
  flex-direction: column;
}
.di-mobile-menu-wrapper .mobile-menu-data nav.di-nav ul li {
  margin: 0 !important;
  border-bottom: 1px solid #ccc;
  position: relative;
}
.di-mobile-menu-wrapper .mobile-menu-data nav.di-nav ul li:after {
  content: "";
  position: absolute;
  right: 22px;
  height: 6px;
  width: 6px;
  border-left: 2px solid #444;
  border-bottom: 2px solid #444;
  transform: rotate(-133deg);
  top: 25px;
}
.di-mobile-menu-wrapper .mobile-menu-data nav.di-nav ul li .nav-item {
  margin: 0 !important;
  padding: 20px;
  display: flex;
  align-items: center;
  font-size: 1.1rem !important;
  font-weight: 600 !important;
  line-height: 1;
  border-radius: 5px;
}
.di-mobile-menu-wrapper .mobile-menu-data nav.di-nav ul li .nav-item.active {
  color: #004c93 !important;
  background: #f9f9f9;
}
.di-mobile-menu-wrapper .mobile-menu-data nav.di-nav ul li .nav-item:before {
  display: none;
}
.di-mobile-menu-wrapper .mobile-menu-data nav.di-nav ul li .nav-item.has-sub-menu {
  display: none !important;
}
.di-mobile-menu-wrapper .mobile-menu-data nav.di-nav ul li div.sub-menu {
  position: relative !important;
  opacity: 1 !important;
  visibility: visible !important;
  margin: 0 !important;
  top: -17px !important;
  background: transparent !important;
  box-shadow: none !important;
  padding: 0 !important;
}
.di-mobile-menu-wrapper .mobile-menu-data nav.di-nav ul li div.sub-menu ul {
  margin: 0 !important;
  padding: 0 !important;
}
.di-mobile-menu-wrapper .mobile-menu-data nav.di-nav ul li div.sub-menu ul li {
  margin: 0 !important;
  display: block !important;
  width: 100% !important;
  border-bottom: 1px solid #ccc;
}
.di-mobile-menu-wrapper .mobile-menu-data nav.di-nav ul li div.sub-menu ul li a {
  font-size: 1.1rem !important;
  padding: 20px !important;
  display: block !important;
  font-weight: 600 !important;
  width: 100% !important;
  line-height: 1;
}
.di-mobile-menu-wrapper .mobile-menu-data nav.di-nav ul li div.sub-menu ul li a .mobile-txt {
  display: inline-block !important;
}
.di-mobile-menu-wrapper .mobile-menu-data nav.di-nav ul li div.sub-menu ul li:last-child {
  border-bottom: 0 !important;
}
.mat-menu-panel {
  width: 180px;
}
/*# sourceMappingURL=mobile-menu.component-I6UNUMQX.css.map */
